
const orderStatusNav: Array<{ name: string; id: number | string }> = [
    {
        name: "全部订单",
        id: "",
    },
    {
        name: "待付款",
        id: 0,
    },
    {
        name: "待核销",
        id: 1,
    },
    {
        name: "已完成",
        id: 2,
    },
    {
        name: "售后",
        id: 3,
    },
];

const columnList: Array<any> = [
    {
        prop: "ordersn",
        label: "订单编号",
        width: 164,
    },
    {
        prop: "create_time",
        label: "下单时间",
        width: 164,
    },
    {
        prop: "project_name",
        label: "尊享卡名称",
        width: 100,
    },
    {
        prop: "project_type_name",
        label: "售价",
        width: 80,
    },
    {
        prop: "goodsprice",
        label: "会员号",
        width: 80,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 80,
    },
    {
        prop: "phone",
        label: "会员手机",
        width: 100,
    },
    {
        prop: "pay_status_text",
        label: "订单状态",
        width: 80,
    },
];

import { defineComponent, inject, ref, onMounted, reactive } from "vue";
import { getOrderTable } from "@/api/http";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

export default defineComponent({
    name: "dataStatistics",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["数据统计"]);
        const headClass = inject("headClass");
        let orderStatus = ref(0),
            loading = ref(false),
            userinfo = ref(false),
            tableData = ref([] as Array<any>),
            currentPage = ref(0),
            pageSize = ref(10),
            total = ref(0),
            screenParameter: any = ref({
                store_id: -1
            } as any),
            dialogTitle = ref(""),
            dataStatistics = ref({} as any),
            selectList = ref({
                Framework:[]
            } as any),
            dialogFormVisible = ref(false),
            orderDetail = ref({
                ordersn: "GD20210520013",
                pay_status_text: "待核销",
            }),
            dialogNavIndex = ref(0),
            dialogWriteoffList = ref([
                { value: "0", label: "补轮胎", number: "还剩1次" },
                { value: "1", label: "抛光打蜡", number: "还剩1次" },
                { value: "2", label: "蜡水洗车", number: "还剩1次" },
            ] as Array<any>),
            dialogWriteoffIndex = ref(""),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入核销码", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });

        let getTableData = () => {
                loading.value = true;
                 Request.axiosInstance({
                    url: 'adminapi/Order/dataStatistics',
                    data: {store_id:screenParameter.value.store_id}
                }).then((res: any) => {
                    dataStatistics.value = res?.content?.list
                })
                
 
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            columnChange = (item: any, type: number) => {
                switch (type) {
                    case 0:
                    dialogFormVisible.value = true
                        break;
                    case 1:
                        // 核销接口未完成
                        break;
                    case 2:
                        // 退款接口未完成
                        break;
                }
            };

        onMounted(async() => {

            await Request.axiosInstance({
                url: 'adminapi/Framework/totalList'
            }).then((res: any) => {
                selectList.value.Framework = [{id:-1,store_name:"请选择"},...res?.content?.list];
            })
            let info;
            let user_info = localStorage.getItem('user_info');
            if (user_info) {
                info = JSON.parse(user_info);
                if (info.store_id==0){
                    userinfo.value = true;
                }
            }
            getTableData();
        });

        return {
            orderStatusNav,
            orderStatus,
            loading,
            tableData,
            userinfo,
            headClass,
            getTableData,
            screenParameter,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
            dialogTitle,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            dialogWriteoffList,
            dialogWriteoffIndex,
            rules,
            columnChange,
            selectList,
            dataStatistics
        };
    },
});
